<div class="vr-vh">

  <div class="vr-vh__head"
       role="button"
       tabindex="0"
       [attr.aria-expanded]="expanded"
       (click)="toggle()"
       (keydown.enter)="toggle()"
       (keydown.space)="$event.preventDefault(); toggle()">
    <mat-icon class="material-icons-outlined vr-vh__icon">bookmarks</mat-icon>
    <span class="vr-vh__title">Watched Vessels</span>
    <span class="vr-vh__count">{{ rows.length }}</span>
    <span class="vr-vh__spacer"></span>
    <mat-icon class="vr-vh__caret">{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
  </div>

  <ng-container *ngIf="expanded">

    <!-- Nothing saved yet. Rendered rather than hidden — the search box and
         the vessel popup's header buttons are what fill this, and nothing else
         in the panel teaches that. -->
    <div class="vr-vh__none" *ngIf="!rows.length">
      <mat-icon class="material-icons-outlined">bookmarks</mat-icon>
      <div>
        <div class="vr-vh__none-title">No watched vessels yet</div>
        <div class="vr-vh__none-note">
          Use the search box on the map, or the watch button on any
          vessel's popup. Every vessel you locate is kept here (the newest 50),
          where you can put it back on the map or refresh its latest position
          and details.
        </div>
      </div>
    </div>

    <div class="vr-vh__list" *ngIf="rows.length" role="listbox" aria-label="Watched Vessels">
      <div class="vr-vh__row"
           *ngFor="let row of rows; trackBy: trackByMmsi"
           role="option"
           tabindex="0"
           [class.is-onmap]="isOnMap(row)"
           [attr.aria-selected]="isOnMap(row)"
           (click)="pick(row)"
           (keydown.enter)="pick(row)"
           (keydown.space)="$event.preventDefault(); pick(row)">

        <!-- The located-marker amber diamond; hollow once the fix is stale. -->
        <span class="vr-vh__diamond" [class.is-stale]="row.stale"></span>

        <span class="vr-vh__text">
          <span class="vr-vh__name" [class.is-unnamed]="!row.isNamed">{{ row.label }}</span>
          <small>
            <ng-container *ngIf="row.isNamed">MMSI {{ row.mmsi }} · </ng-container>
            <ng-container *ngIf="row.ago">{{ row.stale ? 'last known' : 'fix' }} · {{ row.ago }}</ng-container>
            <ng-container *ngIf="!row.ago">no position stored</ng-container>
            <span class="vr-vh__dest" *ngIf="row.destination"> · → {{ row.destination }}</span>
          </small>
        </span>

        <span class="vr-vh__onmap" *ngIf="isOnMap(row)">ON MAP</span>

        <span class="vr-vh__acts">
          <button type="button" class="vr-vh__act is-primary"
                  [disabled]="!row.hasFix"
                  [matTooltip]="!row.hasFix
                    ? 'No stored position — use Refresh to fetch one'
                    : isOnMap(row) ? 'Center the map on this vessel' : 'Put this vessel on the map'"
                  matTooltipPosition="below" matTooltipClass="vr-tip-below"
                  (click)="locateRow(row, $event)">
            <mat-icon class="material-icons-outlined">my_location</mat-icon>
          </button>
          <button type="button" class="vr-vh__act"
                  [disabled]="!!loadingMmsi || !!blocker"
                  [matTooltip]="blocker
                    || 'Get the latest position and details · ' + lookupCost + (lookupCost === 1 ? ' credit' : ' credits')"
                  matTooltipPosition="below" matTooltipClass="vr-tip-below"
                  (click)="refreshRow(row, $event)">
            <mat-icon class="material-icons-outlined"
                      [class.vr-vh__spin]="isLoading(row)">autorenew</mat-icon>
          </button>
          <!-- Off the map, still saved. Only while there IS a marker to take
               down, and `layers_clear` because that is what every other Voyage
               Radar control uses to mean exactly this (both ON MAP bars). -->
          <button type="button" class="vr-vh__act"
                  *ngIf="isOnMap(row)"
                  matTooltip="Take off the map — stays in Watched Vessels"
                  matTooltipPosition="below" matTooltipClass="vr-tip-below"
                  (click)="takeOffMapRow(row, $event)">
            <mat-icon class="material-icons-outlined">layers_clear</mat-icon>
          </button>
          <button type="button" class="vr-vh__act is-danger"
                  matTooltip="Remove from Watched Vessels — permanent"
                  matTooltipPosition="below" matTooltipClass="vr-tip-below"
                  (click)="removeRow(row, $event)">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
          </button>
        </span>
      </div>
    </div>

  </ng-container>

</div>
